<div class="position-relative"  id="{{'item-' + topic.id}}">
    <div class="media card topic-card position-relative" id="{{topic.id}}">
        <div class="timeline-item-badge">
            @switch (topic.type){
                @case ('topic'){
                    {{'topic' | translate }}
                }
                @case ('question'){
                    {{'topic.question' | translate }}
                }
                @case ('issue'){
                    {{'topic.issue' | translate }}
                }
            }
            @if(topic.reviewed.length > 0){
                <review-badge [reviewInfo]="topic.reviewed"></review-badge>
            }
        </div>

        <div class="card-top" (mouseenter)="showTimelineItemOptions=true" (mouseleave)="showTimelineItemOptions=false">
            @switch (topic.type){
                @case ('topic'){
                    <div class="pt-2 pe-2">
                        <i class="fa-light fa-messages-question fa-2x ms-2 pt-1 position-relative" [ngClass]="{'text-secondary': timelineItemEditMode}"></i>
                    </div>
                }
                @case ('question'){
                    <div class="pt-2 pe-2">
                        <i class="fa-light fa-messages-question fa-2x ms-2 pt-1 position-relative" [ngClass]="{'text-secondary': timelineItemEditMode}"></i>
                    </div>
                }
                @case ('issue'){
                    <div class="pt-2 pe-2">
                        <i class="fa-light fa-message-exclamation fa-2x ms-2 pt-1 position-relative" [ngClass]="{'text-secondary': timelineItemEditMode}"></i>
                    </div>
                }
            }

            @if (!timelineItemEditMode){
            <div class="card-comment p-3">
                <span class="card-comment-body fst-italic" [innerHtml]="topic.title.body | removeGifUrls: topic.title.linkPreviews | linky"></span>
                @for (linkPreview of topic.title.linkPreviews; track linkPreview.url){
                    @if(linkPreview.url.slice(-4) === '.gif'){
                        <tm-gif-preview [gifPreview]="toGifPreview(linkPreview)"></tm-gif-preview>
                    }
                }
            </div>
            } @else {
                <tm-edit-topic-box
                            [topic]="topic"
                            (onEdit)="onTopicEdited($event)"
                            (onCancel)="cancelEdit()"></tm-edit-topic-box>
            }
            @if(!(isHandset$ | async)){
            <div class="card-options" [ngClass]="{'active-options': showTimelineItemOptions}">
                @if(!timelineItemEditMode){
                <div>
                    @if(topic.isEditable){
                    <div (click)="editTopic()">
                        <i class="fa-regular fa-pen"
                           [matTooltip]="optionEditText | translate"
                           matTooltipPosition="right"
                           ></i>
                    </div>
                    }
                    @if(topic.isDeletable){
                    <div (click)="deleteTopic()">
                        <i class="fa-regular fa-trash-alt"
                           data-cy="delete-topic"
                           [matTooltip]="optionDeleteText | translate"
                           matTooltipPosition="right"></i>
                    </div>
                    }
                </div>
                @if(!topic.isDeletable){
                <div (click)="reportTopic()">
                    <i class="fa-regular fa-hexagon-exclamation"
                       [matTooltip]="optionReportText | translate"
                       matTooltipPosition="right"></i>
                </div>
                }
                }
            </div>
            } @else {
                @if(!timelineItemEditMode){
                    <div class="card-options card-options-mobile">
                        <button class="btn btn-secondary dropdown-toggle" type="button" [matMenuTriggerFor]="menu">
                            <i class="fa-regular fa-ellipsis-vertical"></i>
                        </button>
                        <mat-menu #menu="matMenu">
                            <ul class="p-0 m-0">
                                @if(topic.isEditable){
                                    <li mat-menu-item class="dropdown-item" (click)="editTopic()">
                                        <i class="fa-regular fa-pen pe-1"></i> {{optionEditText | translate }}
                                    </li>
                                }
                                @if(topic.isDeletable){
                                    <li mat-menu-item class="dropdown-item" (click)="deleteTopic()">
                                        <i class="fa-regular fa-trash-alt pe-1"></i> {{optionDeleteText | translate }}
                                    </li>
                                } @else {
                                    <li mat-menu-item class="dropdown-item" (click)="reportTopic()">
                                        <i class="fa-regular fa-hexagon-exclamation pe-1"></i> {{optionReportText | translate }}
                                    </li>
                                }
                            </ul>
                        </mat-menu>
                    </div>
                }
            }
        </div>

        @if(!timelineItemEditMode){
        <div (mouseenter)="showTimelineItemOptions=true" (mouseleave)="showTimelineItemOptions=false">
            @for(linkPreview of topic.title.linkPreviews; track linkPreview.url){
                @if(linkPreview.url.slice(-4) !== '.gif'){
                    <div>
                        <tm-link-preview [linkPreview]="linkPreview"></tm-link-preview>
                    </div>
                }
            }
        </div>

        <div class="media-bottom card-bottom">
            <tm-reactions [timelineItem]="topic"
                          (onReacted)="onReacted($event)"
                          (onToggleThreads)="toggleThreads()"
                          (onDiscuss)="discuss()"></tm-reactions>

            @if(showThreads){
                <tm-threads [timelineItem]="topic" #threadsComponent
                            [userInfos]="userInfos"
                            (onThreadsUpdated)="onThreadsUpdated($event)"></tm-threads>
            }
        </div>
        }
    </div>
<!-- 
    @if (topic.educationalCard){
        <div class="position-absolute mb-md-3 hide-for-mobile top-0 start-100 ms-4"
             [class]="{'hide-for-large-screen': !isOdd, 'hide-oft': isOdd }">
            <tm-educational-card
                    [educCardId]="topic.educationalCard"
                    [threadComponent]="getThreadsComponent"></tm-educational-card>
        </div>
    } -->
    @if(topic.managerPanel){
        <div class="manager-panel-wrapper"
             [class]="isOdd ? 'odd-timeline-item': 'even-timeline-item'">
            <tm-manager-panel [managerPanel]="topic.managerPanel"
                              [reviewed]="topic.reviewed.length !== 0"></tm-manager-panel>
        </div>
    }
</div>